var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("四川智胜慧旅科技有限公司版权所有 蜀ICP备17027145号-4")]),_c('p',[_vm._v("四川·成都 武侯区武科东一路7号")]),_c('p',[_vm._v("服务热线：028-82871691")])])
}]

export { render, staticRenderFns }